/**
 * @generated SignedSource<<04245929b50fa066dfacbad3e77abc82>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VaccinationStatusesMultiSelectInput_query$data = {
  readonly vaccinationStatuses: {
    readonly nodes: ReadonlyArray<{
      readonly name: string;
      readonly rowId: any;
    } | null | undefined>;
  } | null | undefined;
  readonly " $fragmentType": "VaccinationStatusesMultiSelectInput_query";
};
export type VaccinationStatusesMultiSelectInput_query$key = {
  readonly " $data"?: VaccinationStatusesMultiSelectInput_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"VaccinationStatusesMultiSelectInput_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VaccinationStatusesMultiSelectInput_query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            "SEQUENCE_ASC"
          ]
        }
      ],
      "concreteType": "VaccinationStatusConnection",
      "kind": "LinkedField",
      "name": "vaccinationStatuses",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "VaccinationStatus",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rowId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "vaccinationStatuses(orderBy:[\"SEQUENCE_ASC\"])"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "db949320b62d0099a22c2b9d877ff29c";

export default node;
